/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import api from '../../../services/api';
import CryptoJS from "crypto-js"
import moment from 'moment'
import 'moment/locale/pt';

import ReactExport from "react-export-excel";
import FilterModal from "./components/filterModal"
import NewPolModal from "./components/newPolModal"

import FixedContainer from '../../../components/Container';
import { Box, Button, Modal, Typography } from '@mui/material';
import LoadingComponent from '../../../components/LoadingComponent';
import CustomizedTables from '../../../components/Table';
import EditIcon from '@mui/icons-material/Edit';
import EditModal from './components/editModal';
import { cpfMask } from '../../../utils/functions';
import { replaceDotForComma } from '../../../utils/Regex';
import { enqueueSnackbar } from 'notistack';
import { GetFetch } from '../../../services/apiBase';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const ByCpf = ({ history }) => {

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [filter, setFilter] = useState(false);
  const [open, setOpen] = useState(false);
  const [openNewModal, setOpenNewModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [filterValues, setFilterValues] = useState('');

  const [listTradeAgreement, setListTradeAgreement] = useState(null);
  const [modalFilter, setModalFilter] = useState('');
  const [tradeAgreementToEdit, setTradeAgreementToEdit] = useState({});
  
  const COLUMNSTABLE = [
    {
      headerName: 'CPF',
      type: 'CPF',
      value: {
        first: {
          value: 'document_number'
        },
      },
      noData: 'Não informado'
    },
    {
      headerName: 'Valor de investimento inicial',
      type: 'money',
      value: {
        first: {
          value: 'amount_start'
        }
      }
    },
    {
      headerName: 'Valor de investimento final',
      type: 'money',
      value: {
        first: {
          value: 'amount_end'
        }
      }
    },
    {
      headerName: 'Taxa',
      type: 'percent',
      value: {
        first: {
          value: 'rate'
        }
      }
    },
    {
      headerName: 'Status',
      type: 'bool',
      value: {
        first: {
          value: 'is_actived'
        }
      },
      trueMessage: 'Ativado',
      falseMessage: 'Desativado',
      noData: 'Não informado'
    },
  ]

  const handleOpenEditModal = (agreement) => {
    setTradeAgreementToEdit(agreement);
    setOpenEditModal(true)
  }

  const handleOpen = () => {
    setOpen(true)
    setFilter(false)
  }

  const handleOpenNewModal = () => {
    setOpenNewModal(true)
  }

  const handleClose = () => {
    setOpen(false);
    setOpenNewModal(false);
    setOpenEditModal(false);
  }

  const handleClearFilter = () => {
    setFilter(false);
    setFilterValues('');
  }

  const handleIcon = (item) => {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '50%',
          cursor: 'pointer'
        }}
        onClick={() => handleOpenEditModal(item)}
      >
        <EditIcon />
      </Box>
    )
  }

  const getListTradeAgreement = useCallback(async () => {
    setLoading(true)
    try {
      const response = await GetFetch('/financial/listTradeAgreement');
      setListTradeAgreement(response.data);
      setError(false)
    } catch (error) {
      console.log(error)
      setError(true)
    } finally {
      setLoading(false)
    }
  }, []);

  const getFilteredTradeAgreementList = async () => {
    setLoading(true)
    try {
      const response = await GetFetch(`/financial/listTradeAgreement?document_number=${modalFilter}`);
      if (response.data.error) {
        enqueueSnackbar(response.data.error, { variant: 'error' });
        
        setFilter(false)
        return
      }
      if (response.data.length === 0) {
        enqueueSnackbar('Não possui nenhuma politica para este CPF', { variant: 'error' });
        
        setFilter(false)
        return
      }
      setListTradeAgreement(response.data);
      setError(false)
    } catch (error) {
      console.log(error)
      setError(true)
    } finally {
      setLoading(false)
    }
  }

  const tableComponent = () => {
    return (
      <Box>
        {listTradeAgreement && listTradeAgreement.length > 0
          ? 
          <>
            <CustomizedTables
              data={listTradeAgreement}
              columns={COLUMNSTABLE}
              moreOptionsTitle={'Editar'}
              moreOptions={handleIcon}
            />
          </>
          :
          <Box sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            margin: 3
          }}>
            <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
              Não foram encontradas CPRFs
            </Typography>
          </Box>
        }
      </Box>
    )
  }

  const errorMessage = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '24px', paddingBottom: 2, color: 'red' }}>
          Ocorreu um erro ao buscar as CPRF's resgatadas
        </Typography>
      </Box>
    )
  }

  const exportExcelComponent = () => {
    return (
      <ExcelFile element={
        <Button variant="contained">Exportar para Excel</Button>
      } filename="Politicas_comerciais-Por_CPF">
        <ExcelSheet data={listTradeAgreement} name="Politicas_comerciais-Por_CPF">
          <ExcelColumn label="CPF" value={(col) => col.document_number ? cpfMask(col.document_number) : "Não informado"}/>
          <ExcelColumn label="Valor_de_investimento_inicial" value={(col) => col.amount_start ? Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(col.amount_start) : "Não informado"}/>
          <ExcelColumn label="Valor_de_investimento_final" value={(col) => col.amount_end ? Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(col.amount_end) : "Não informado"}/>
          <ExcelColumn label="Taxa" value={(col) => col.rate ? col.rate.toString().match(/./) != null ? `${replaceDotForComma(col.rate.toString())} %` : `${col.rate} %` : "Não informado"}/>
          <ExcelColumn label="Status" value={(col) => col.is_actived ? 'Ativado' : 'Desativado'} />
      </ExcelSheet>
      </ExcelFile>
    )
  }

  useEffect(() => {
    if (filter) {
      getFilteredTradeAgreementList()
    } else {
      getListTradeAgreement()
    }
  }, [filter]);

  moment.locale('pt')
  return (
    <>
      <FixedContainer>
        <Box sx={{
          width: '100%',
          height: '100%',
          backgroundColor: '#F9FBFD',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          boxShadow: 3,
          borderRadius: '10px',
          padding: 2,
        }}>
          <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 1 }}>
            Politicas comerciais/Por CPF
          </Typography>

          <Box sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginBottom: 1,
            marginTop: 1,
          }}>
              
            <Box>
              <Button variant="contained" color='success' sx={{ marginRight: 2 }} onClick={handleOpenNewModal}>Novo</Button>
              {filter ?
                <Button variant="contained" sx={{ marginRight: 2}} color="error" onClick={handleClearFilter}>Limpar filtros</Button>
                :
                <Button variant="contained" sx={{ marginRight: 2 }} onClick={handleOpen}>Filtros</Button>
              }
              {exportExcelComponent()}
            </Box>
          </Box>
          {loading ? <LoadingComponent /> :
            error ? errorMessage() :
            listTradeAgreement && listTradeAgreement.length === 0 ? 
              <Box sx={{
                display: 'flex',
                width: '100%',
                justifyContent: 'center'
              }}>
                <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
                  No momento não existem políticas por CPF
                </Typography>
              </Box>
              :
              <>
                {tableComponent()}
              </>
          }
        </Box>
      </FixedContainer>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <FilterModal
          setFilter={setFilter}
          setProps={setModalFilter} 
          onClose={handleClose}
        />
      </Modal>

      <Modal
        open={openNewModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <NewPolModal
          onClose={handleClose}
          getList={getListTradeAgreement}
        />
      </Modal>

      <Modal
        open={openEditModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <EditModal
          onClose={handleClose}
          agreement={tradeAgreementToEdit}
          setTradeAgreementToEdit={setTradeAgreementToEdit}
          getList={getListTradeAgreement}
        />
      </Modal>
    </>
  );
}

export default ByCpf;
